import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import PrimeVue from 'primevue/config';
import 'primeicons/primeicons.css'
import locale from '@/assets/zh-cn'; // 导入中文语言包
import '@/assets/global.css';
import Tooltip from 'primevue/tooltip';
import Aura from '@primevue/themes/aura';
import '@/assets/fonts/fonts.css';




createApp(App).directive('tooltip', Tooltip).use(router).use(PrimeVue, { 
    theme: {
        preset: Aura,
        options: {
            prefix: 'p',
            darkModeSelector: 'system',
            cssLayer: false
        }
    },
    locale:locale
 }).mount('#app')

